import React from 'react'
import * as styles from './style'

const LivePulse = (): JSX.Element => <i className={styles.root}></i>
export default LivePulse
